import type { IOrderNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createOrderNote,
  updateNote: updateOrderNote,
  deleteNote: deleteOrderNote,
} = makeNoteService<IOrderNote>('/api/ordernotes', 'orderNote')
